const COOKIE_NAME = 'verse8_auth_token';
const MAX_AGE_SECONDS = 60 * 60 * 24; // 24h

// Admin app is fully client-side; cookieStore API isn't yet supported in Safari, so document.cookie stays.
export function saveAuthToken(token: string): void {
  // biome-ignore lint/suspicious/noDocumentCookie: client-side admin app, no SSR; cookieStore unsupported in Safari
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(token)}; path=/; max-age=${MAX_AGE_SECONDS}; samesite=strict`;
}

export function readAuthToken(): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]+)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function clearAuthToken(): void {
  // biome-ignore lint/suspicious/noDocumentCookie: client-side admin app, no SSR; cookieStore unsupported in Safari
  document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; samesite=strict`;
}

export interface DecodedV8Token {
  user: string;
  email?: string;
  walletAddress: string;
  iat: number;
  exp: number;
}

export function decodeV8Token(token: string): DecodedV8Token | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4);
    const decoded = JSON.parse(atob(padded)) as Partial<DecodedV8Token>;
    if (typeof decoded.walletAddress !== 'string' || typeof decoded.exp !== 'number') return null;
    return decoded as DecodedV8Token;
  } catch {
    return null;
  }
}

export function isTokenExpired(decoded: DecodedV8Token): boolean {
  return decoded.exp * 1000 <= Date.now();
}
